import { Drawer } from '@mafc/trolly';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useFeature } from '@mafc/appshell';

import useAction from 'hooks/useAction';
import { ICheckoutState } from 'pages/Checkout/redux/reducer';
import { applyPromo } from 'pages/Checkout/redux/actions/promo.action';

import { AppliedVoucher } from 'network/response/ICart';
import { ICartState } from 'pages/Cart/redux/reducer';
import { isExisty } from 'utils/helpers.util';
import PromoCodeDrawerFooter from './PromoCodeDrawerFooter';
import PromoCodeDrawerBody from './PromoCodeDrawerBody';
import PromoCodeHeader from './PromoCodeDrawerHeader';
import TrackerCheckout from 'utils/Tracker.checkout';

const PromoCodeDrawer: React.FC<{
  isOpen: boolean;
  closeDrawer: () => void;
}> = ({ isOpen, closeDrawer }) => {
  const { t } = useTranslation();
  const isAvailablePromotionEnabled = useFeature('checkout.available_promotion.enabled').on;

  const { loading } = useSelector((state: { checkout: ICheckoutState }) => state.checkout.promo);

  const [applyPromoAction] = useAction(applyPromo);

  const appliedPromo: AppliedVoucher | null = useSelector((state: { cart: ICartState }) =>
    state.cart.cartData.appliedVouchers ? state.cart.cartData.appliedVouchers[0] : null
  );

  const [promoCode, setPromoCode] = useState('');

  const onPromoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPromoCode(e.target.value);
  };

  const applyHandler = () => {
    const applyPromoSuccessCallback =
      isAvailablePromotionEnabled && TrackerCheckout.voucherAppliedManually.bind(null, promoCode);
    applyPromoAction(promoCode, t, applyPromoSuccessCallback);
  };

  const isPromoApplied = isExisty(appliedPromo);

  return (
    <Drawer
      anchor={['bottom', null, 'right']}
      isOpen={isOpen}
      onClose={closeDrawer}
      title={<PromoCodeHeader appliedPromo={appliedPromo} />}
      variant="float"
      containerStyles={{
        borderTopLeftRadius: [4, null, null, 0],
        borderTopRightRadius: [4, null, null, 0],
      }}
      isTitleBorder={false}
      contentStyles={{ pt: 1, borderRadius: '20px' }}
      width={[null, null, '480px']}
      data-testid="promo-code-drawer"
    >
      <PromoCodeDrawerBody
        appliedPromo={appliedPromo}
        promoCode={promoCode}
        onPromoChange={onPromoChange}
        onApply={applyHandler}
      />

      <PromoCodeDrawerFooter
        promoCode={promoCode}
        loading={loading}
        isPromoApplied={isPromoApplied}
        onApply={applyHandler}
        closeDrawer={closeDrawer}
      />
    </Drawer>
  );
};

export default PromoCodeDrawer;
